import api from './api';

/**
 * Get user's cart
 */
export const getCart = async () => {
  const response = await api.get('/cart');
  return response.data;
};

/**
 * Add item to cart by product variant ID
 * @param {string} productVariantId - UUID of the product variant
 * @param {number} quantity - Quantity to add
 */
export const addToCart = async (productVariantId, quantity = 1) => {
  const response = await api.post('/cart/items', {
    productVariantId,
    quantity
  });
  return response.data;
};

/**
 * Add custom lamp configuration to cart
 * Creates a product variant on-the-fly if it doesn't exist
 * @param {Object} config - Custom lamp configuration
 * @param {string} config.baseId - Base ID (e.g., "1", "20")
 * @param {string} config.shadeId - Shade ID (e.g., "1", "28")
 * @param {string} config.baseColor - Base color (e.g., "black", "white")
 * @param {string} config.shadeColor - Shade color (e.g., "ivory", "black")
 * @param {string} config.baseName - Display name for base
 * @param {string} config.shadeName - Display name for shade
 * @param {string} config.baseColorName - Display name for base color
 * @param {string} config.shadeColorName - Display name for shade color
 * @param {number} config.quantity - Quantity (default: 1)
 */
export const addCustomToCart = async (config) => {
  console.log('[cartService] Adding custom config to cart:', config);
  const response = await api.post('/cart/custom', {
    baseId: String(config.baseId),
    shadeId: String(config.shadeId),
    baseColor: config.baseColor,
    shadeColor: config.shadeColor,
    baseName: config.baseName,
    shadeName: config.shadeName,
    baseColorName: config.baseColorName,
    shadeColorName: config.shadeColorName,
    quantity: config.quantity || 1
  });
  return response.data;
};

/**
 * Update cart item quantity
 * @param {string} cartItemId - UUID of the cart item
 * @param {number} quantity - New quantity
 */
export const updateCartItem = async (cartItemId, quantity) => {
  const response = await api.put(`/cart/items/${cartItemId}`, {
    quantity
  });
  return response.data;
};

/**
 * Remove item from cart
 * @param {string} cartItemId - UUID of the cart item
 */
export const removeCartItem = async (cartItemId) => {
  const response = await api.delete(`/cart/items/${cartItemId}`);
  return response.data;
};

/**
 * Clear entire cart
 */
export const clearCart = async () => {
  const response = await api.delete('/cart');
  return response.data;
};

/**
 * Get cart item count
 */
export const getCartCount = async () => {
  const response = await api.get('/cart/count');
  return response.data;
};

export default {
  getCart,
  addToCart,
  addCustomToCart,
  updateCartItem,
  removeCartItem,
  clearCart,
  getCartCount,
};
